"use client";

import Script from "next/script";
import { GTM_ID, EEA_COUNTRIES, STORAGE_KEYS } from "@/lib/constants";

function getInitialConsentDefaults(): string {
  const eeaRegions = EEA_COUNTRIES.join("', '");

  return `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    
    gtag('consent', 'default', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied',
      'wait_for_update': 500,
      'regions': ['${eeaRegions}']
    });
    
    gtag('consent', 'default', {
      'ad_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted',
      'analytics_storage': 'granted'
    });
    
    // Check for existing consent
    try {
      var stored = localStorage.getItem('${STORAGE_KEYS.CONSENT}');
      if (stored) {
        var consent = JSON.parse(stored);
        var expiryMs = 180 * 24 * 60 * 60 * 1000;
        if (Date.now() - consent.timestamp < expiryMs) {
          gtag('consent', 'update', {
            'ad_storage': consent.ads ? 'granted' : 'denied',
            'ad_user_data': consent.ads ? 'granted' : 'denied',
            'ad_personalization': consent.ads ? 'granted' : 'denied',
            'analytics_storage': consent.analytics ? 'granted' : 'denied'
          });
        }
      }
    } catch (e) {}
  `;
}

export function GTMScripts() {
  if (!GTM_ID) return null;

  return (
    <>
      <Script
        id="gtm-consent-defaults"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{ __html: getInitialConsentDefaults() }}
      />
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`}
      />
      <Script
        id="gtm-dataLayer"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'gtm.start': new Date().getTime(),
              event: 'gtm.js'
            });
          `,
        }}
      />
    </>
  );
}

export function GTMNoScript() {
  if (!GTM_ID) return null;

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      />
    </noscript>
  );
}
